import React                     from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
});

type INavLinkProps = WithStyle<ReturnType<typeof styles>, NavLinkProps>;

class NavLinkInternal extends React.Component<INavLinkProps> {
  constructor(props: INavLinkProps) {
    super(props);
  }

  render() {
    const {children, ...props} = this.props;

    return (
      <NavLink {...props}>
        {children}
      </NavLink>
    );
  }
}

export default withStyles<NavLinkProps>(styles, NavLinkInternal);
